import Title from '@/components/Title';
export default {
  components: {
    Title
  },
  props: {
    title: {
      type: String,
      default: 'Advantages'
    },
    casesList: {
      type: Array,
      required: true
    },
    customWidth: {
      type: Number,
      default: 410
    }
  }
};